module.exports = __webpack_public_path__ + "img/we.91ba5945.svg";